// extracted by mini-css-extract-plugin
module.exports = {"articles":"Articles_articles__W_Gix","articlesList":"Articles_articlesList__hqbB1","articlesLink":"Articles_articlesLink__zZfaS"};